export default __webpack_public_path__ + "static/media/gerrit-vermeulen.fae68b06.jpg";